var scope_0 = require('/builds/bootsite/www.gatsbyjs.cn/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/builds/bootsite/www.gatsbyjs.cn/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/223e49577a130159a592a107cfba3c9b.js').default;
var scope_2 = require('/builds/bootsite/www.gatsbyjs.cn/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6e31c1d84726e08b007fd6be0ed08e4f.js').default;
var scope_3 = require('/builds/bootsite/www.gatsbyjs.cn/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a85a85be43e040e579016980fc0b869b.js').default;
var scope_4 = require('/builds/bootsite/www.gatsbyjs.cn/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a901ce98ab8af92ae8045acd00523e5c.js').default;
var scope_5 = require('/builds/bootsite/www.gatsbyjs.cn/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b2ded798a1ced3991c3794fe27055683.js').default;
var scope_6 = require('/builds/bootsite/www.gatsbyjs.cn/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c813189ffed6b4b02d009c54e19d272b.js').default;
var scope_7 = require('/builds/bootsite/www.gatsbyjs.cn/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e2fae4f521ffd0782e8b6edeff594a82.js').default;
var scope_8 = require('/builds/bootsite/www.gatsbyjs.cn/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e7e18889c07879ce670f865178f04d8b.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8 )
    